import { ItemApi } from '@/api';
import { apiConfiguration } from '@/api/config';
import { FilterOptions } from '@/types/API';

export const itemApi = new ItemApi(apiConfiguration);

export type GetItemQueryFnParams = { slug: string; track_view?: boolean };

export const getItemQueryFn = async (slug: string, track_view: boolean) =>
    itemApi.itemControllerGetBySlug(slug, track_view);

export const getRecentsQueryFn = async () =>
    itemApi.itemControllerGetRecentlyViewedItems();

export const getCurrentBiddingItems = async ({
    active,
    offset,
    limit,
    sortBy,
    filterBy
}: {
    active?: boolean;
    sortBy?: FilterOptions.Winning | FilterOptions.Loosing;
    filterBy?: FilterOptions.Winning | FilterOptions.Loosing;
    offset: number;
    limit: number;
}) => itemApi.itemControllerGetCurrentBiddingItems(offset, limit, active, sortBy, filterBy);

export const getUserOwningItemsFn = async () => itemApi.itemControllerGetOwningItems();

export const getRelatedItemsFn = async (itemId: string) => itemApi.itemControllerGetRelatedById(itemId);

export const linkItemByQrCodeFn = async (data: { qrCode: string }) => itemApi.itemControllerLinkItemByQrCode(data.qrCode);
